import { cx } from 'utils/cx'

import styles from './Pricing.module.scss'
import fukkuStyles from 'fukku/styles/classes.module.scss'
import text from 'fukku/styles/texts.module.scss'

type AllowedAlign = 'left' | 'right'

interface PricingProps {
	'data-testid'?: string
	price: string
	additionalPrices?: string[] | null
	hasDiscount?: boolean
	className?: string
	align?: AllowedAlign
	screenReaderLabel?: string
}

export function Pricing({
	'data-testid': dataTestId = 'myPurchases.price',
	price,
	additionalPrices = [],
	hasDiscount = false,
	align = 'right',
	className,
	screenReaderLabel,
}: PricingProps) {
	const alignClasses = {
		left: styles.left,
		right: styles.right,
	}

	return (
		<div className={cx(styles.wrapper, alignClasses[align], className)}>
			{screenReaderLabel && (
				<span className={fukkuStyles.srOnly}>{screenReaderLabel}</span>
			)}
			<span
				className={cx(hasDiscount && styles.discount, styles.price)}
				data-testid={dataTestId}
				{...(screenReaderLabel && { 'aria-hidden': true })}
			>
				{price}
			</span>
			{additionalPrices &&
				additionalPrices.map((additionalPrice, idx) => (
					<span
						key={additionalPrice}
						data-testid={`${dataTestId}.aditional.${idx}`}
						className={cx(text.bodyS, hasDiscount && styles.discount)}
					>
						{additionalPrice}
					</span>
				))}
		</div>
	)
}
